import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../ui/Loader';

// This component is used for routes that require super admin access
const SuperAdminRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useSelector(state => state.auth);
  
  if (loading) {
    return <Loader />;
  }
  
  if (!isAuthenticated || !user || !user.is_super_admin) {
    // Redirect to admin dashboard if not super admin
    return <Navigate to="/admin" replace />;
  }
  
  return children;
};

export default SuperAdminRoute;